// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"178":"35832f6b","662":"f26d85c9","817":"1bb21a15"}[chunkId] + ".chunk.js";
};